import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ScopedSiteProvider } from '../-scopedSiteProvider/ScopedSiteProvider.tsx';

export const Route = createFileRoute('/(app)/utils')({
  component: () => (
    <ScopedSiteProvider>
      <Outlet />
    </ScopedSiteProvider>
  ),
});
